import React, { useContext, useEffect, useState, useRef } from "react";
import { Data } from "../App";
import { useNavigate } from "react-router-dom";
import InputText from "./InputText";
import PrefSelect from "./PrefSelect";
import PrivacyPolicy from "./PrivacyPolicy";

export default function FormBody({ selectedList }) {
  const { formData, setFormData, errors, setErrors, sofaList } =
    useContext(Data);
  const navigate = useNavigate();
  // const [privacy, setPrivacy] = useState(false);
  const scrollToRef = useRef(null);
  // 背景色変えるためのref
  const nameDtRef = useRef(null);
  const nameDdRef = useRef(null);
  const furiganaDtRef = useRef(null);
  const furiganaDdRef = useRef(null);
  const postDtRef = useRef(null);
  const postDdRef = useRef(null);
  const prefDtRef = useRef(null);
  const prefDdRef = useRef(null);
  const address1DtRef = useRef(null);
  const address1DdRef = useRef(null);
  const address2DtRef = useRef(null);
  const address2DdRef = useRef(null);
  const mailDtRef = useRef(null);
  const mailDdRef = useRef(null);

  //生地名を抽出しフォームデータにセット
  useEffect(() => {
    const kijiName = selectedList.map((item) => {
      return item.kiji;
    });
    setFormData({ ...formData, kijiname: JSON.stringify(kijiName) });
    // エラー回避
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 住所検索
  useEffect(() => {
  const autoAddressFill = async () => {
    // only fire once a full 7-digit zip code is entered
    if (!formData.post || formData.post.length !== 7) return;

    try {
      const res = await fetch(
        `https://api.zipaddress.net/?zipcode=${formData.post}`
      );
      if (!res.ok) return; // bad response, bail out quietly

      const text = await res.text();
      if (!text) return; // empty body, nothing to parse

      const json = JSON.parse(text);
      if (json.code === 200) {
        setFormData({
          ...formData,
          pref: json.data.pref,
          address1: json.data.city + json.data.town,
        });
        setErrors({ ...errors, pref: null, address1: null });
        postDtRef.current.style.backgroundColor = "#dcdddd";
        postDdRef.current.style.backgroundColor = "#ededed";
        prefDtRef.current.style.backgroundColor = "#dcdddd";
        prefDdRef.current.style.backgroundColor = "#ededed";
        address1DtRef.current.style.backgroundColor = "#dcdddd";
        address1DdRef.current.style.backgroundColor = "#ededed";
      }
    } catch (err) {
      console.error("Zip code lookup failed:", err);
    }
  };
  autoAddressFill();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [formData.post]);// 郵便番号入力を監視

  // 確認画面遷移前に未入力項目に赤色付ける用
  let dtRef;
  let ddRef;
  function changeColor(elm) {
    switch (elm) {
      case "name" || "lastname":
        dtRef = nameDtRef;
        ddRef = nameDdRef;
        break;
      case "furigana1" || "furigana2":
        dtRef = furiganaDtRef;
        ddRef = furiganaDdRef;
        break;
      case "post":
        dtRef = postDtRef;
        ddRef = postDdRef;
        break;
      case "pref":
        dtRef = prefDtRef;
        ddRef = prefDdRef;
        break;
      case "address1":
        dtRef = address1DtRef;
        ddRef = address1DdRef;
        break;
      case "address2":
        dtRef = address2DtRef;
        ddRef = address2DdRef;
        break;
      case "email" || "emailcheck":
        dtRef = mailDtRef;
        ddRef = mailDdRef;
        break;
      default:
    }
    dtRef.current.style.backgroundColor = "rgba(130, 67, 81, .3)";
    ddRef.current.style.backgroundColor = "rgba(130,67,81,.1)";
  }

  // 確認画面遷移
  function toConfirm() {
    let flg = false; // エラーの有無判定用フラグ
    // 必須項目の未入力を確認し、空欄があればエラー
    let newErrors = {};
    Object.keys(errors).forEach((error) => {
      if (errors[error] === "") {
        newErrors = { ...newErrors, [error]: "*必須項目です" };
        changeColor(error);
      } else if (errors[error] !== null) {
        changeColor(error);
      }
    });
    setErrors(Object.assign({}, errors, newErrors));

    for (let i = 0; i < Object.keys(errors).length; i++) {
      // エラーがあれば最初の該当箇所にスクロール
      if (errors[Object.keys(errors)[i]] !== null) {
        flg = false;
        const target = document.querySelector(`#${Object.keys(errors)[i]}`);
        scrollToRef.current = target;
        scrollToRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      } else {
        // エラーが無ければフラグをtrue
        flg = true;
      }
    }

    // 問題が無ければ確認画面に遷移
    if (flg) {
      navigate("confirm/");
    }
  }

  return (
    <>
      <h3>
        <b>お名前</b>
      </h3>
      <dl className="form_common">
        <dt ref={nameDtRef}>
          <b>漢字</b>
          <b className="required">必須</b>
        </dt>
        <dd ref={nameDdRef}>
          <span>姓　</span>
          <InputText
            name="lastname"
            sanitize={true}
            required={true}
            dtRef={nameDtRef}
            ddRef={nameDdRef}
            placeholder="（例：牧）"
          />
          <span>名　</span>
          <InputText
            name="name"
            sanitize={true}
            required={true}
            dtRef={nameDtRef}
            ddRef={nameDdRef}
            placeholder="（例：太郎）"
          />
        </dd>

        <dt ref={furiganaDtRef}>
          <b>ふりがな</b>
          <b className="required">必須</b>
        </dt>
        <dd ref={furiganaDdRef}>
          <span>せい</span>
          <InputText
            name="furigana1"
            type="hiragana"
            sanitize={true}
            required={true}
            dtRef={furiganaDtRef}
            ddRef={furiganaDdRef}
            placeholder="（例：まき）"
          />
          <span>めい</span>
          <InputText
            name="furigana2"
            type="hiragana"
            sanitize={true}
            required={true}
            dtRef={furiganaDtRef}
            ddRef={furiganaDdRef}
            placeholder="（例：たろう）"
          />
        </dd>
      </dl>

      <h3>
        <b>生地サンプルお届け先</b>
      </h3>
      <dl>
        <dt ref={postDtRef}>
          <b>郵便番号</b>
          <b className="required">必須</b>
        </dt>
        <dd ref={postDdRef} className="col">
          <p>ハイフンなし・半角</p>
          <InputText
            name="post"
            type="number"
            required={true}
            length={7}
            sanitize={true}
            dtRef={postDtRef}
            ddRef={postDdRef}
            placeholder="（例：4660058）"
          />
        </dd>

        <dt ref={prefDtRef}>
          <b>都道府県</b>
          <b className="required">必須</b>
        </dt>
        <dd ref={prefDdRef} className="col">
          <PrefSelect dtRef={prefDtRef} ddRef={prefDdRef} />
        </dd>

        <dt ref={address1DtRef}>
          <b>市区町村</b>
          <b className="required">必須</b>
        </dt>
        <dd ref={address1DdRef}>
          <InputText
            name="address1"
            sanitize={true}
            required={true}
            dtRef={address1DtRef}
            ddRef={address1DdRef}
            placeholder="（例：名古屋市昭和区白金）"
          />
        </dd>

        <dt ref={address2DtRef}>
          <b>番地・建物名</b>
          <b className="required">必須</b>
        </dt>
        <dd ref={address2DdRef} className="col">
          <p>ローマ数字は算用数字にてご入力ください［例：Ⅰ⇒1、Ⅱ⇒2］</p>
          <InputText
            name="address2"
            sanitize={true}
            required={true}
            dtRef={address2DtRef}
            ddRef={address2DdRef}
            placeholder="（例：1-4-3 NOYESビル 112号）"
          />
        </dd>

        <dt ref={mailDtRef}>
          <b>メールアドレス</b>
          <b className="required">必須</b>
        </dt>
        <dd ref={mailDdRef} className="col">
          <p>ご入力いただいたアドレスに受付確認メールをお送りいたします</p>
          <InputText
            name="email"
            type="email"
            required={true}
            dtRef={mailDtRef}
            ddRef={mailDdRef}
            placeholder="noyes@ny-k.co.jp"
          />
          <p>確認のため再度ご入力ください</p>
          <InputText
            name="emailcheck"
            type="emailcheck"
            required={true}
            dtRef={mailDtRef}
            ddRef={mailDdRef}
            placeholder="noyes@ny-k.co.jp"
          />
        </dd>
      </dl>

      <h3>
        <b>アンケート</b>
      </h3>
      <dl className="form_enquate">
        <dt>
          <b>生地請求は初めてですか？</b>
        </dt>
        <dd>
          <label className={formData.enquate1 === "初めて" ? "isChecked" : ""}>
            <input
              type="checkbox"
              onChange={(e) =>
                setFormData({ ...formData, enquate1: e.target.value })
              }
              value={"初めて"}
            />
            初めて
          </label>
          <label
            className={formData.enquate1 === "2回目以降" ? "isChecked" : ""}
          >
            <input
              type="checkbox"
              onChange={(e) =>
                setFormData({ ...formData, enquate1: e.target.value })
              }
              value={"2回目以降"}
            />
            2回目以降
          </label>
        </dd>

        <dt>
          <b>ご検討ソファ</b>
        </dt>
        <dd>
          <div className="select">
            <select
              onChange={(e) =>
                setFormData({ ...formData, enquate2: e.target.value })
              }
              value={formData.enquate2}
            >
              <option value={null}>-選択してください</option>
              {sofaList.map((sofa, i) => {
                return (
                  <option key={i} value={sofa.name}>
                    {sofa.name}
                  </option>
                );
              })}
            </select>
          </div>
        </dd>

        <dt>
          <b>ご購入時期</b>
        </dt>
        <dd>
          <div className="select">
            <select
              onChange={(e) =>
                setFormData({ ...formData, enquate3: e.target.value })
              }
              value={formData.enquate3}
            >
              <option value={null}>-選択してください</option>
              <option value="今すぐにでも">今すぐにでも</option>
              <option value="1ヶ月以内">1ヶ月以内</option>
              <option value="3ヶ月以内">3ヶ月以内</option>
              <option value="半年以内">半年以内</option>
              <option value="1年以内">1年以内</option>
              <option value="もっと先">もっと先</option>
              <option value="未定">未定</option>
            </select>
          </div>
        </dd>

        <dt>
          <b>年齢</b>
        </dt>
        <dd>
          <div className="select">
            <select
              onChange={(e) =>
                setFormData({ ...formData, enquate4: e.target.value })
              }
              value={formData.enquate4}
            >
              <option value={null}>-選択してください</option>
              <option value="20代前半より前">20代前半より前</option>
              <option value="20代後半">20代後半</option>
              <option value="30代前半">30代前半</option>
              <option value="30代後半">30代後半</option>
              <option value="40代前半">40代前半</option>
              <option value="40代後半">40代後半</option>
              <option value="50代前半">50代前半</option>
              <option value="55歳後半以上の方">55歳後半以上の方</option>
            </select>
          </div>
        </dd>

        <dt>
          <b>住宅環境</b>
        </dt>
        <dd>
          <div className="select">
            <select
              onChange={(e) =>
                setFormData({ ...formData, enquate5: e.target.value })
              }
              value={formData.enquate5}
            >
              <option value={null}>-選択してください</option>
              <optgroup label="集合住宅">
                <option value="集合住宅1K">1K</option>
                <option value="集合住宅2K">2K</option>
                <option value="集合住宅1LDK">1LDK</option>
                <option value="集合住宅2LDK">2LDK</option>
                <option value="集合住宅3K">3K</option>
                <option value="集合住宅3LDK">3LDK</option>
                <option value="集合住宅それ以上">それ以上</option>
              </optgroup>
              <optgroup label="1戸建て">
                <option value="一戸建て3K">3K</option>
                <option value="一戸建て3LDK">3LDK</option>
                <option value="1戸建てそれ以上">それ以上</option>
              </optgroup>
            </select>
          </div>
        </dd>

        <dt>
          <b>ご意見・ご要望等ございましたらご記入ください</b>
        </dt>
        <dd>
          <textarea
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
            value={formData.message}
          ></textarea>
        </dd>
      </dl>

      <dl>
        <dt>メールマガジン購読</dt>
        <dd className="col">
          <small>NOYESの最新情報を毎週金曜日にお届けしております。</small>
          <label className={formData.mm === "希望する" ? "isChecked" : ""}>
            <input
              type="checkbox"
              onChange={() =>
                setFormData({
                  ...formData,
                  mm: formData.mm === "希望する" ? "希望しない" : "希望する",
                })
              }
            />
            希望する
            <span></span>
          </label>
        </dd>
      </dl>

      <PrivacyPolicy />

      <button className="formBtn" onClick={() => toConfirm()}>
        <b>同意して確認画面へ</b>
      </button>
    </>
  );
}
